export default Object.freeze({
  LOGIN: '/login',
  USERS: '/users',
  TRAININGS: '/trainingsManagement',
  USERS_RESERVATION: '/usersReservation',
  RESET_PASSWORD: '/resetPassword',
  USERS_UPDATE_PASSOWORD: '/users/updatePassword',
  RESERVATIONS_MANAGEMENT: '/reservationManagement',
  COPY_TRAININGS: '/copyTrainings',
  MODERATOR_USER_TRACKING: '/moderatorUsersTracking',
  USER_STATISTICS: '/usersStatistics',
  CUSTOM_TRAININGS: 'customTraining',
  WORKOUTS_MANAGEMENT: 'workoutsManagement',
  TRAINING_SESSION: 'trainingSession',
  RELEASE_NOTES: 'releaseNotes',
  ADMIN_RELEASE_NOTES: 'adminReleaseNotes',
  LOCATIONS_MANAGEMENT: 'locationsManagement',
  ADMIN_WORKOUTS_REVIEW: 'adminWorkoutsReview'
});